import {
  OPEN_SNACKBAR,
  SnackbarActionTypes,
  ISnackbarState,
  CLOSE_SNACKBAR,
} from './types'

export const initialState: ISnackbarState = {
  message: '',
  severity: 'success',
  time: 4000,
  isOpen: false,
}

const snackbarReducer = (
  state = initialState,
  action: SnackbarActionTypes
): ISnackbarState => {
  switch (action.type) {
    case OPEN_SNACKBAR:
      return {
        ...state,
        message: action.message,
        severity: action.severity,
        time: action.time,
        isOpen: true,
      }

    case CLOSE_SNACKBAR:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default snackbarReducer
